import { UntypedFormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core/lib/components/formly.field.config';

/**
 * Default for material autocomplete components where the value is bound to the input component
 * where the user can technically enter any string value.
 */
export function DefaultAvailableOptionsValidator(
    control: UntypedFormControl,
    configuration: FormlyFieldConfig
): boolean {
    if (
        !Array.isArray(configuration.templateOptions?.options) ||
        configuration.templateOptions?.options.length === 0
    ) {
        return true;
    }
    if (typeof configuration.templateOptions.options[0] === 'object') {
        /* user input will be string unless selected option
         * --> validation failed if string and not object
         * (won't check undefined since that's part of mandatory field validation)
         */
        return typeof control.value !== 'string';
    } else if (typeof configuration.templateOptions.options[0] === 'string') {
        return configuration.templateOptions.options.indexOf(control.value) !== -1;
    }
    // Should not handle dates or numbers in this validator
    return true;
}
